module.exports = __webpack_public_path__ + "static/media/mi_hraswo.08016e80.ogg";